(function () {
  function escapeHtml(value) {
    if (value === null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isSafeImageUrl(url) {
    return typeof url === 'string' && /^https:\/\//i.test(url);
  }

  function isSafeLinkUrl(url) {
    if (typeof url !== 'string' || !url) return false;
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  function formatJoinDate(iso) {
    if (!iso) return '';
    var date = new Date(iso);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long' });
  }

  function getUsernameFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return (params.get('u') || '').trim();
  }

  var PUBLIC_PROFILE_SELECT =
    'id, username, display_name, avatar_url, bio, creative_role, location_display, website_url, created_at, is_founder';
  var PUBLIC_SUBMISSION_SELECT = 'id, creator_name, project_title, project_url, category, location_display, created_at';
  var DOODLE_WINDOW_DAYS = 3;

  function doodleStrokesToSvg(strokeData, size) {
    size = size || 90;
    var strokes = (strokeData && strokeData.strokes) || [];
    var paths = strokes
      .map(function (stroke) {
        var points = (stroke.points || [])
          .map(function (p) { return (p[0] * 100).toFixed(1) + ',' + (p[1] * 100).toFixed(1); })
          .join(' ');
        var color = /^#[0-9a-fA-F]{3,6}$/.test(stroke.color) ? stroke.color : '#eef2ee';
        return (
          '<polyline points="' + points + '" fill="none" stroke="' + color +
          '" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />'
        );
      })
      .join('');
    return (
      '<svg viewBox="0 0 100 100" width="' + size + '" height="' + size +
      '" preserveAspectRatio="xMidYMid meet">' + paths + '</svg>'
    );
  }

  function fetchPublicProfile(supabase, username) {
    return supabase
      .from('profiles')
      .select(PUBLIC_PROFILE_SELECT)
      .eq('username', username)
      .maybeSingle()
      .then(function (result) {
        if (result.error) throw result.error;
        return result.data;
      });
  }

  // Aggregate-only RPC (get_public_xp_total) — xp_transactions itself is
  // self-only via RLS, so this never exposes per-transaction reason/amount
  // rows, only the sum needed to derive a public level name.
  function fetchXpTotal(supabase, profileId) {
    return supabase
      .rpc('get_public_xp_total', { p_profile_id: profileId })
      .then(function (result) {
        if (result.error) throw result.error;
        return result.data || 0;
      });
  }

  function fetchBadges(supabase, profileId) {
    return Promise.all([
      supabase.from('badges').select('id, slug, name, description'),
      supabase.from('user_badges').select('badge_id').eq('profile_id', profileId),
    ]).then(function (results) {
      var badgesResult = results[0];
      var userBadgesResult = results[1];
      if (badgesResult.error) throw badgesResult.error;
      if (userBadgesResult.error) throw userBadgesResult.error;

      var earnedIds = {};
      (userBadgesResult.data || []).forEach(function (row) {
        earnedIds[row.badge_id] = true;
      });

      var order = window.ReigningWet.BADGE_ORDER || [];
      return (badgesResult.data || [])
        .filter(function (badge) {
          return earnedIds[badge.id];
        })
        .sort(function (a, b) {
          return order.indexOf(a.slug) - order.indexOf(b.slug);
        });
    });
  }

  function fetchApprovedSubmissions(supabase, profileId) {
    return supabase
      .from('submissions')
      .select(PUBLIC_SUBMISSION_SELECT)
      .eq('profile_id', profileId)
      .eq('is_published', true)
      .order('created_at', { ascending: false })
      .then(function (result) {
        if (result.error) throw result.error;
        return result.data || [];
      });
  }

  function fetchDoodles(supabase, profileId) {
    var cutoff = new Date(Date.now() - DOODLE_WINDOW_DAYS * 24 * 60 * 60 * 1000).toISOString();
    return supabase
      .from('doodles')
      .select('id, stroke_data, created_at')
      .eq('profile_id', profileId)
      .eq('is_removed', false)
      .gte('created_at', cutoff)
      .order('created_at', { ascending: false })
      .then(function (result) {
        if (result.error) throw result.error;
        return result.data || [];
      });
  }

  function renderNotFound(container) {
    container.innerHTML =
      '<div class="rw-profile-card rw-profile-empty">' +
      '<div class="rw-profile-eyebrow">the current</div>' +
      '<h1 class="rw-profile-name">Profile Not Found</h1>' +
      '<p class="rw-account-subtext">This creator hasn’t joined Reigning Wet yet, or the link is incorrect.</p>' +
      '</div>';
  }

  function renderError(container) {
    container.innerHTML =
      '<div class="rw-profile-card rw-profile-empty">' +
      '<p class="rw-account-subtext">Could not load this profile right now. Please try again.</p>' +
      '</div>';
  }

  function renderProfile(container, profile, xpTotal, badges, submissions, doodles) {
    var levelInfo = window.ReigningWet.getLevelInfo(xpTotal);
    var avatarStyle = isSafeImageUrl(profile.avatar_url)
      ? ' style="background-image:url(' + escapeHtml(profile.avatar_url) + ')"'
      : '';
    var joinDate = formatJoinDate(profile.created_at);

    var metaBits = [];
    if (profile.creative_role) metaBits.push(escapeHtml(profile.creative_role));
    if (profile.location_display) metaBits.push(escapeHtml(profile.location_display));
    if (joinDate) metaBits.push('Joined ' + joinDate);

    var websiteHtml = '';
    if (isSafeLinkUrl(profile.website_url)) {
      var label = profile.website_url.replace(/^https?:\/\//, '').replace(/\/$/, '');
      websiteHtml =
        '<a class="rw-profile-website" href="' +
        escapeHtml(profile.website_url) +
        '" target="_blank" rel="noopener noreferrer">' +
        escapeHtml(label) +
        '</a>';
    }

    var badgesHtml = badges.length
      ? badges
          .map(function (badge) {
            return (
              '<div class="rw-account-badge" title="' +
              escapeHtml(badge.description || '') +
              '">' +
              escapeHtml(badge.name) +
              '</div>'
            );
          })
          .join('')
      : '<div class="rw-account-badge rw-account-badge--empty">No badges yet</div>';

    var submissionsHtml = submissions.length
      ? submissions
          .map(function (submission) {
            var linkHtml = isSafeLinkUrl(submission.project_url)
              ? '<a class="rw-profile-wave-link" href="' +
                escapeHtml(submission.project_url) +
                '" target="_blank" rel="noopener noreferrer">View wave →</a>'
              : '';
            var tagBits = [];
            if (submission.category) tagBits.push(escapeHtml(submission.category));
            if (submission.location_display) tagBits.push(escapeHtml(submission.location_display));

            return (
              '<div class="rw-profile-wave">' +
              '<div class="rw-profile-wave-title">' +
              escapeHtml(submission.project_title) +
              '</div>' +
              (tagBits.length ? '<div class="rw-profile-wave-tag">' + tagBits.join(' · ') + '</div>' : '') +
              linkHtml +
              '</div>'
            );
          })
          .join('')
      : '<p class="rw-account-subtext">No public waves yet.</p>';

    var doodlesHtml = doodles.length
      ? '<div class="rw-profile-doodles-grid">' +
          doodles
            .map(function (doodle) {
              return '<div class="rw-profile-doodle">' + doodleStrokesToSvg(doodle.stroke_data, 100) + '</div>';
            })
            .join('') +
          '</div>'
      : '<p class="rw-account-subtext">No doodles on the wall right now.</p>';

    container.innerHTML =
      '<div class="rw-profile-card">' +
      '<div class="rw-profile-eyebrow">the current</div>' +
      '<div class="rw-profile-header">' +
      '<div class="rw-profile-avatar"' +
      avatarStyle +
      '></div>' +
      '<div>' +
      '<h1 class="rw-profile-name' +
      (profile.is_founder ? ' rw-founder-name' : '') +
      '">' +
      (profile.is_founder ? '★ ' : '') +
      escapeHtml(profile.display_name || profile.username) +
      '</h1>' +
      '<div class="rw-profile-username">@' +
      escapeHtml(profile.username) +
      '</div>' +
      (metaBits.length ? '<div class="rw-profile-meta">' + metaBits.join(' · ') + '</div>' : '') +
      websiteHtml +
      '</div>' +
      '</div>' +
      (profile.bio ? '<p class="rw-profile-bio">' + escapeHtml(profile.bio) + '</p>' : '') +
      '<div class="rw-account-xp-block">' +
      '<div class="rw-account-level-row"><span class="rw-account-level-name">' +
      escapeHtml(levelInfo.name) +
      '</span></div>' +
      '<div class="rw-account-badges">' +
      badgesHtml +
      '</div>' +
      '</div>' +
      '<div class="rw-profile-waves">' +
      '<h2 class="rw-profile-section-heading">Waves Shared</h2>' +
      '<div class="rw-profile-waves-list">' +
      submissionsHtml +
      '</div>' +
      '</div>' +
      '<div class="rw-profile-doodles">' +
      '<h2 class="rw-profile-section-heading">Doodles</h2>' +
      doodlesHtml +
      '</div>' +
      '</div>';
  }

  function boot() {
    var container = document.getElementById('rw-profile-page');
    if (!container) return;

    var username = getUsernameFromUrl();
    if (!username) {
      renderNotFound(container);
      return;
    }

    function withSupabase() {
      var supabase = window.ReigningWet.supabase;

      fetchPublicProfile(supabase, username)
        .then(function (profile) {
          if (!profile) {
            renderNotFound(container);
            return;
          }

          return Promise.all([
            fetchXpTotal(supabase, profile.id).catch(function () {
              return 0;
            }),
            fetchBadges(supabase, profile.id).catch(function () {
              return [];
            }),
            fetchApprovedSubmissions(supabase, profile.id).catch(function () {
              return [];
            }),
            fetchDoodles(supabase, profile.id).catch(function () {
              return [];
            }),
          ]).then(function (results) {
            renderProfile(container, profile, results[0], results[1], results[2], results[3]);
          });
        })
        .catch(function (error) {
          if (window.console) console.error('[ReigningWet] Failed to load public profile:', error);
          renderError(container);
        });
    }

    if (window.ReigningWet.supabase) {
      withSupabase();
    } else {
      document.addEventListener('reigningwet:supabase-ready', withSupabase, { once: true });
      document.addEventListener(
        'reigningwet:supabase-error',
        function () {
          renderError(container);
        },
        { once: true }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
